// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {Modulo} from "services-translation/modules/base/modulo";

import {TraduccionCmpInsistWindowChangeOpinion} from "./insist_window/change_opinion";
import {TraduccionCmpInsistWindowDataP1App} from "./insist_window/data_p1_app";
import {TraduccionCmpInsistWindowDataP1} from "./insist_window/data_p1";
import {TraduccionCmpInsistWindowPay} from "./insist_window/pay";
import {TraduccionCmpInsistWindowPlatformActionMain} from "./insist_window/platform_action_main";
import {TraduccionCmpInsistWindowPlatformActionSecondary} from "./insist_window/platform_action_secondary";

export class TraduccionCmpInsistWindow extends Modulo {
    /* STATIC */
    // public static ID: string = "cmp.insist_window";
    // public static VERSION: Date = new Date("2024-02-26T07:59:13.368Z");
    // public static HASH: string = "374a6dafd8518588e59daa1d3df758fd";

    private static CACHE: {[lang: string]: TraduccionCmpInsistWindow} = {};

    public static build(lang: IIdioma): TraduccionCmpInsistWindow {
        return this.CACHE[lang.idioma] ??= new this(lang);
    }

    /* INSTANCE */
    public data_p1: string;
    public data_p1_app: string;
    public pay: string;
    public change_opinion: string;

    #platform_action_main: TraduccionCmpInsistWindowPlatformActionMain;
    #platform_action_secondary: TraduccionCmpInsistWindowPlatformActionSecondary;

    private constructor(_lang: IIdioma) {
        super(_lang);

        this.data_p1 = TraduccionCmpInsistWindowDataP1.build(this._lang).toString();
        this.data_p1_app = TraduccionCmpInsistWindowDataP1App.build(this._lang).toString();
        this.pay = TraduccionCmpInsistWindowPay.build(this._lang).toString();
        this.#platform_action_main = TraduccionCmpInsistWindowPlatformActionMain.build(this._lang);
        this.change_opinion = TraduccionCmpInsistWindowChangeOpinion.build(this._lang).toString();
        this.#platform_action_secondary = TraduccionCmpInsistWindowPlatformActionSecondary.build(this._lang);
    }

    public platform_action_main(key: string) {
        return this.#platform_action_main.render(key);
    }

    public platform_action_secondary(key: string) {
        return this.#platform_action_secondary.render(key);
    }}

export default (lang: IIdioma)=>TraduccionCmpInsistWindow.build(lang);
